// src/config.js — ShipFast v4 Configuration
export const ADMIN_UID = "ZB4GqPSBYiabUAGdDuWbEQTt3aI2";
export const MAX_ORDERS_PER_HOUR = 15;

// ── EmailJS ──
// Sign up at https://www.emailjs.com (free: 200 emails/month)
// Create a service, then a template with these variables:
//   {{to_email}}, {{to_name}}, {{subject}}, {{heading}}, {{message}}, {{details}}, {{site_url}}
export const EMAILJS_CONFIG = {
  serviceId: "service_shipfast",
  templateId: "template_shipfast",
  publicKey: "YOUR_EMAILJS_PUBLIC_KEY",
  enabled: false, // flip to true once configured
};

// Email event types
export const EMAIL_EVENTS = {
  quote_sent: {
    subject: "ShipFast: You have a new quote!",
    heading: "Quote Received",
    message: "We've reviewed your shipment and have a quote ready for you.",
  },
  order_confirmed: {
    subject: "ShipFast: Order confirmed — label in progress",
    heading: "Order Confirmed",
    message: "You've accepted the quote. We're creating your shipping label now.",
  },
  label_ready: {
    subject: "ShipFast: Your shipping label is ready!",
    heading: "Label Ready",
    message: "Great news! Your shipping label is ready to download.",
  },
  void_approved: {
    subject: "ShipFast: Void request approved",
    heading: "Void Approved",
    message: "Your request to void the shipping label has been approved.",
  },
  void_denied: {
    subject: "ShipFast: Void request update",
    heading: "Void Denied",
    message: "Your void request has been reviewed and was not approved. The label remains active.",
  },
  order_cancelled: {
    subject: "ShipFast: Order cancelled",
    heading: "Order Cancelled",
    message: "Your order has been cancelled as requested.",
  },
};

export const SERVICES = [
  { id: "ground", name: "UPS Ground", eta: "3-5 business days", icon: "\u{1F4E6}", baseRate: 7.99, perLb: 0.50 },
  { id: "3day", name: "UPS 3 Day Select", eta: "3 business days", icon: "\u{1F69B}", baseRate: 12.99, perLb: 0.75 },
  { id: "2day", name: "UPS 2nd Day Air", eta: "2 business days", icon: "\u2708\uFE0F", baseRate: 18.99, perLb: 1.00 },
  { id: "nextday", name: "UPS Next Day Air", eta: "1 business day", icon: "\u26A1", baseRate: 29.99, perLb: 1.50 },
];

export const ORDER_STATUSES = {
  pending: { label: "Awaiting Quote", color: "#f59e0b" },
  quoted: { label: "Quoted", color: "#3b82f6" },
  confirmed: { label: "Confirmed", color: "#8b5cf6" },
  completed: { label: "Label Ready", color: "#10b981" },
  void_requested: { label: "Void Requested", color: "#f97316" },
  voided: { label: "Voided", color: "#6b7280" },
  cancelled: { label: "Cancelled", color: "#ef4444" },
};

export const CHAT_QUICK_REPLIES = [
  { label: "Processing", text: "Your label is being processed. Should be ready shortly!" },
  { label: "Confirm Address", text: "Could you please confirm your shipping address is correct?" },
  { label: "Refund Issued", text: "A refund has been issued for your voided label." },
  { label: "Need Info", text: "I need a bit more information about your shipment. Can you provide the package dimensions?" },
  { label: "Shipped", text: "Your package has been shipped! You can track it using the tracking number provided." },
  { label: "Thank You", text: "Thank you for choosing ShipFast! Let us know if you need anything else." },
];

export const US_STATES = [
  { code: "AL", name: "Alabama" }, { code: "AK", name: "Alaska" }, { code: "AZ", name: "Arizona" },
  { code: "AR", name: "Arkansas" }, { code: "CA", name: "California" }, { code: "CO", name: "Colorado" },
  { code: "CT", name: "Connecticut" }, { code: "DE", name: "Delaware" }, { code: "FL", name: "Florida" },
  { code: "GA", name: "Georgia" }, { code: "HI", name: "Hawaii" }, { code: "ID", name: "Idaho" },
  { code: "IL", name: "Illinois" }, { code: "IN", name: "Indiana" }, { code: "IA", name: "Iowa" },
  { code: "KS", name: "Kansas" }, { code: "KY", name: "Kentucky" }, { code: "LA", name: "Louisiana" },
  { code: "ME", name: "Maine" }, { code: "MD", name: "Maryland" }, { code: "MA", name: "Massachusetts" },
  { code: "MI", name: "Michigan" }, { code: "MN", name: "Minnesota" }, { code: "MS", name: "Mississippi" },
  { code: "MO", name: "Missouri" }, { code: "MT", name: "Montana" }, { code: "NE", name: "Nebraska" },
  { code: "NV", name: "Nevada" }, { code: "NH", name: "New Hampshire" }, { code: "NJ", name: "New Jersey" },
  { code: "NM", name: "New Mexico" }, { code: "NY", name: "New York" }, { code: "NC", name: "North Carolina" },
  { code: "ND", name: "North Dakota" }, { code: "OH", name: "Ohio" }, { code: "OK", name: "Oklahoma" },
  { code: "OR", name: "Oregon" }, { code: "PA", name: "Pennsylvania" }, { code: "RI", name: "Rhode Island" },
  { code: "SC", name: "South Carolina" }, { code: "SD", name: "South Dakota" }, { code: "TN", name: "Tennessee" },
  { code: "TX", name: "Texas" }, { code: "UT", name: "Utah" }, { code: "VT", name: "Vermont" },
  { code: "VA", name: "Virginia" }, { code: "WA", name: "Washington" }, { code: "WV", name: "West Virginia" },
  { code: "WI", name: "Wisconsin" }, { code: "WY", name: "Wyoming" },
];

export function sanitize(str, maxLen = 500) {
  if (typeof str !== "string") return "";
  return str.replace(/<[^>]*>/g, "").slice(0, maxLen);
}
export function sanitizeForSubmit(str, maxLen = 500) {
  if (typeof str !== "string") return "";
  return str.replace(/<[^>]*>/g, "").trim().slice(0, maxLen);
}
export function isValidZip(zip) { return /^\d{5}(-\d{4})?$/.test(zip); }
export function isValidEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); }

export function formatTime(timestamp) {
  if (!timestamp) return "";
  const d = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  const now = new Date();
  const diff = now - d;
  if (diff < 60000) return "Just now";
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}h ago`;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: d.getFullYear() !== now.getFullYear() ? "numeric" : undefined });
}
export function formatFullDate(timestamp) {
  if (!timestamp) return "";
  const d = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
}

export function estimateShipping(serviceId, weight, dims) {
  const svc = SERVICES.find((s) => s.id === serviceId) || SERVICES[0];
  if (!weight || weight <= 0) return null;
  let cost = svc.baseRate + (weight * svc.perLb);
  if (dims?.length && dims?.width && dims?.height) {
    const dimWeight = (dims.length * dims.width * dims.height) / 139;
    if (dimWeight > weight) cost += (dimWeight - weight) * svc.perLb * 0.5;
  }
  return Math.max(cost, svc.baseRate).toFixed(2);
}

// ── Send status email ──
export async function sendStatusEmail(toEmail, toName, orderId, eventType, extraDetails = "") {
  if (!EMAILJS_CONFIG.enabled) {
    console.log(`[Email] ${eventType} -> ${toEmail} (disabled)`);
    return false;
  }
  const evt = EMAIL_EVENTS[eventType];
  if (!evt) return false;
  try {
    const res = await fetch("https://api.emailjs.com/api/v1.6/email/send", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        service_id: EMAILJS_CONFIG.serviceId,
        template_id: EMAILJS_CONFIG.templateId,
        user_id: EMAILJS_CONFIG.publicKey,
        template_params: {
          to_email: toEmail,
          to_name: toName || "Customer",
          subject: evt.subject,
          heading: evt.heading,
          message: evt.message,
          details: extraDetails,
          order_id: orderId?.slice(0, 8) || "",
          site_url: window.location.origin,
        },
      }),
    });
    return res.ok;
  } catch (err) {
    console.error("[Email] Failed:", err);
    return false;
  }
}

// ── CSV Export ──
export function exportOrdersCSV(orders) {
  const headers = ["Order ID","Date","Customer","Email","From","To","Service","Weight","Status","Price","Tracking","Priority"];
  const rows = orders.map((o) => [
    o.id, o.createdAt?.toDate ? o.createdAt.toDate().toISOString() : "",
    o.userName || "", o.userEmail || "",
    `${o.senderCity} ${o.senderState}`, `${o.recipientCity} ${o.recipientState}`,
    o.service, o.weight, o.status, o.quotedPrice || "", o.trackingNumber || "", o.priority || "normal",
  ]);
  const csv = [headers, ...rows].map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `shipfast-orders-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

// ── Clipboard ──
export async function copyToClipboard(text) {
  try { await navigator.clipboard.writeText(text); return true; }
  catch { const t = document.createElement("textarea"); t.value = text; document.body.appendChild(t); t.select(); document.execCommand("copy"); document.body.removeChild(t); return true; }
}

// ── UPS Tracking URL ──
export function getUPSTrackingUrl(trackingNumber) {
  if (!trackingNumber) return null;
  return `https://www.ups.com/track?tracknum=${encodeURIComponent(trackingNumber)}`;
}

// ── Sound notification ──
let soundEnabled = true;
export function setSoundEnabled(v) { soundEnabled = v; }
export function isSoundEnabled() { return soundEnabled; }
export function playNotificationSound(type = "message") {
  if (!soundEnabled) return;
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    if (type === "message") {
      osc.frequency.value = 880;
      gain.gain.value = 0.08;
      osc.start();
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.2);
      osc.stop(ctx.currentTime + 0.2);
    } else if (type === "success") {
      osc.frequency.value = 660;
      gain.gain.value = 0.08;
      osc.start();
      setTimeout(() => { osc.frequency.value = 880; }, 100);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4);
      osc.stop(ctx.currentTime + 0.4);
    } else {
      osc.frequency.value = 440;
      gain.gain.value = 0.06;
      osc.start();
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.15);
      osc.stop(ctx.currentTime + 0.15);
    }
  } catch {}
}

// ── Smart Auto-Reply Bot (keyword-based, free) ──
export function generateBotReply(messageText, order) {
  const msg = messageText.toLowerCase().trim();
  const statusInfo = ORDER_STATUSES[order?.status] || {};

  // Keyword patterns and responses
  const patterns = [
    {
      keywords: ["status", "where", "update", "what's happening", "whats happening", "progress"],
      reply: () => {
        if (!order) return "I'd be happy to help with your order status! Could you select an order from the list?";
        const statusLabel = statusInfo.label || order.status;
        let extra = "";
        if (order.status === "pending") extra = " Our team is reviewing it and will send you a quote soon.";
        if (order.status === "quoted") extra = ` Your quoted price is $${order.quotedPrice}. You can confirm or cancel from your dashboard.`;
        if (order.status === "confirmed") extra = " We're working on creating your shipping label now.";
        if (order.status === "completed") extra = order.trackingNumber ? ` Your tracking number is ${order.trackingNumber}.` : " Your label is ready to download from your dashboard.";
        if (order.status === "void_requested") extra = " Our team is reviewing your void request.";
        return `Your order #${order.id.slice(0, 8)} is currently: ${statusLabel}.${extra}`;
      },
    },
    {
      keywords: ["track", "tracking number", "tracking #", "ups"],
      reply: () => {
        if (!order) return "Please select an order first so I can look up tracking info.";
        if (order.trackingNumber) return `Your tracking number is: ${order.trackingNumber}\n\nTrack it here: https://www.ups.com/track?tracknum=${order.trackingNumber}`;
        if (order.status === "completed") return "Your label is ready but tracking info may take a few hours to update in the UPS system.";
        return "Tracking information will be available once your label is created and shipped.";
      },
    },
    {
      keywords: ["price", "cost", "how much", "quote", "estimate", "rate", "pricing"],
      reply: () => {
        if (!order) return "I can help with pricing! Select an order, or check the rate comparison tool on the order form.";
        if (order.quotedPrice) return `Your quoted price for this order is $${order.quotedPrice}. This is the final price.`;
        if (order.status === "pending") {
          const est = order.service && order.weight ? estimateShipping(order.service, parseFloat(order.weight), { length: parseFloat(order.length) || 0, width: parseFloat(order.width) || 0, height: parseFloat(order.height) || 0 }) : null;
          return est ? `Your order is awaiting a quote. Estimated price based on your details: ~$${est}. The final quote may vary.` : "Your order is being reviewed. You'll receive a quote soon!";
        }
        return "Check the rate comparison tool when placing a new order to see estimated prices for all services.";
      },
    },
    {
      keywords: ["void", "cancel", "refund", "return"],
      reply: () => {
        if (!order) return "To request a void or cancellation, go to your order details and click the appropriate button.";
        if (order.status === "void_requested") return "Your void request is already submitted and under review. Our team will process it shortly.";
        if (order.status === "voided") return "This order has already been voided.";
        if (order.status === "cancelled") return "This order has already been cancelled.";
        if (["completed", "confirmed"].includes(order.status)) return "You can request a void from your order details page. Click 'Request Void' and our team will review it.";
        if (order.status === "pending") return "Since this order hasn't been quoted yet, you can cancel it directly from your dashboard.";
        return "For void or cancellation requests, please use the buttons on your order details page.";
      },
    },
    {
      keywords: ["label", "download", "print", "shipping label"],
      reply: () => {
        if (!order) return "Labels are available once your order is completed. Check your order details to download.";
        if (order.status === "completed" && order.labelUrl) return "Your shipping label is ready! You can download it from your order details page. Click the 'Download Label' button.";
        if (order.status === "completed") return "Your order is marked complete. The label should be available on your order details page.";
        return "Your label will be available for download once the order is completed and the label is uploaded.";
      },
    },
    {
      keywords: ["eta", "delivery", "arrive", "when", "how long", "time"],
      reply: () => {
        if (!order) return "Delivery times depend on the service selected. Ground is 3-5 days, 3 Day Select is 3 days, 2nd Day Air is 2 days, and Next Day Air is 1 business day.";
        const svc = SERVICES.find(s => s.id === order.service);
        if (svc) return `You selected ${svc.name} which has an estimated delivery time of ${svc.eta}. This starts from when the package is shipped.`;
        return "Delivery time depends on your selected service. Check your order details for the service and ETA.";
      },
    },
    {
      keywords: ["help", "support", "human", "person", "talk"],
      reply: () => "I'm JS Bot, an automated assistant. For complex questions, click the '🚨 Agent' button below to flag this chat as urgent — a real person will respond as soon as possible!",
    },
    {
      keywords: ["hello", "hi", "hey", "good morning", "good afternoon", "good evening"],
      reply: () => "Hey there! 👋 I'm JS Bot, your automated shipping assistant. I can help with order status, tracking, pricing, labels, and more. What do you need help with?",
    },
    {
      keywords: ["thank", "thanks", "appreciate"],
      reply: () => "You're welcome! If you need anything else, just ask. Happy shipping! 📦",
    },
    {
      keywords: ["weight", "dimension", "size", "heavy", "big", "large"],
      reply: () => "We support packages of various sizes. When placing an order, enter your package weight and dimensions (length × width × height) for accurate pricing. Dimensional weight may apply for large, lightweight packages.",
    },
    {
      keywords: ["insurance", "insure", "protection", "damage"],
      reply: () => "You can add shipping insurance when placing your order. Just check the 'Insurance' option on the order form for extra protection on valuable items.",
    },
    {
      keywords: ["signature", "sign"],
      reply: () => "Signature confirmation is available as an option when placing your order. It requires the recipient to sign upon delivery for added security.",
    },
  ];

  // Check each pattern
  for (const pattern of patterns) {
    for (const keyword of pattern.keywords) {
      if (msg.includes(keyword)) {
        return pattern.reply();
      }
    }
  }

  // Default fallback
  return "I'm not sure I understand. I can help with: order status, tracking, pricing, labels, delivery times, voids, and more. Or click '🚨 Agent' to chat with a real person!";
}

// ── Auto-save drafts ──
const DRAFT_KEY = "shipfast_order_draft";
export function saveDraft(form) {
  try { sessionStorage.setItem(DRAFT_KEY, JSON.stringify(form)); } catch {}
}
export function loadDraft() {
  try { const d = sessionStorage.getItem(DRAFT_KEY); return d ? JSON.parse(d) : null; } catch { return null; }
}
export function clearDraft() {
  try { sessionStorage.removeItem(DRAFT_KEY); } catch {}
}

// ── PDF Receipt ──
export function generateReceipt(order) {
  const { jsPDF } = require("jspdf");
  const doc = new jsPDF();
  const gold = [212, 160, 83];
  const dark = [30, 41, 59];
  const gray = [100, 116, 139];

  // Header
  doc.setFillColor(...gold);
  doc.rect(0, 0, 210, 40, "F");
  doc.setTextColor(10, 10, 10);
  doc.setFontSize(28);
  doc.setFont("helvetica", "bold");
  doc.text("SHIPFAST", 20, 27);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Shipping Receipt", 80, 27);

  // Order info
  let y = 55;
  doc.setTextColor(...dark);
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text(`Order #${order.id.slice(0, 8).toUpperCase()}`, 20, y);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...gray);
  doc.setFontSize(10);
  doc.text(`Date: ${formatFullDate(order.createdAt)}`, 120, y);

  // Status
  y += 12;
  doc.setTextColor(...gold);
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.text(`Status: ${ORDER_STATUSES[order.status]?.label || order.status}`, 20, y);

  // Addresses
  y += 16;
  doc.setDrawColor(...gold);
  doc.setLineWidth(0.5);
  doc.line(20, y, 190, y);
  y += 10;

  doc.setTextColor(...dark);
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.text("FROM:", 20, y);
  doc.text("TO:", 110, y);
  y += 7;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(order.senderName || "", 20, y);
  doc.text(order.recipientName || "", 110, y);
  y += 5;
  doc.setTextColor(...gray);
  doc.text(order.senderStreet || "", 20, y);
  doc.text(order.recipientStreet || "", 110, y);
  y += 5;
  if (order.senderApt) { doc.text(order.senderApt, 20, y); y += 5; }
  doc.text(`${order.senderCity}, ${order.senderState} ${order.senderZip}`, 20, y);
  doc.text(`${order.recipientCity}, ${order.recipientState} ${order.recipientZip}`, 110, y);

  // Package details
  y += 14;
  doc.setDrawColor(...gold);
  doc.line(20, y, 190, y);
  y += 10;
  doc.setTextColor(...dark);
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.text("PACKAGE DETAILS", 20, y);
  y += 8;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  const svc = SERVICES.find((s) => s.id === order.service) || SERVICES[0];
  doc.text(`Service: ${svc.name} (${svc.eta})`, 20, y); y += 6;
  doc.text(`Weight: ${order.weight} lbs`, 20, y); y += 6;
  if (order.length) { doc.text(`Dimensions: ${order.length} x ${order.width} x ${order.height} in`, 20, y); y += 6; }
  if (order.insurance) { doc.text("Insurance: Yes", 20, y); y += 6; }
  if (order.signature) { doc.text("Signature Required: Yes", 20, y); y += 6; }

  // Price
  if (order.quotedPrice) {
    y += 6;
    doc.setDrawColor(...gold);
    doc.line(20, y, 190, y);
    y += 10;
    doc.setTextColor(...dark);
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("TOTAL PAID", 20, y);
    doc.setTextColor(...gold);
    doc.text(`$${order.quotedPrice}`, 170, y, { align: "right" });
  }

  // Tracking
  if (order.trackingNumber) {
    y += 12;
    doc.setTextColor(...dark);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Tracking Number:", 20, y);
    doc.setFont("helvetica", "normal");
    doc.text(order.trackingNumber, 65, y);
    y += 5;
    doc.setTextColor(...gray);
    doc.setFontSize(8);
    doc.text("Track at: ups.com/track", 20, y);
  }

  // Footer
  doc.setDrawColor(...gold);
  doc.line(20, 270, 190, 270);
  doc.setTextColor(...gray);
  doc.setFontSize(8);
  doc.text("Thank you for choosing ShipFast! — shipfast-9e48a.web.app", 105, 278, { align: "center" });

  doc.save(`ShipFast-Receipt-${order.id.slice(0, 8)}.pdf`);
}
